/*
 * @Description:
 * @version:
 * @Author: guyifeng
 * @Date: 2020-09-27 15:05:46
 * @LastEditors: guyifeng
 * @LastEditTime: 2020-10-13 15:36:25
 */
/**
 * 工程文件类型的消息
 */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import MessageContainer from '@/components/message/items/message-container';
import MessageAvatar from '@/components/message/items/message-avatar';
import { SEND_MESSAGE, bus } from '@/event/message_events';
import styles from './styles.module.scss';

const ProjectMessage = ({
  avatar,
  fromMe,
  avatarClassName,
  senderOid,
  senderType,
  message,
  error,
  msgContent,
}) => {
  let messageJSON = {};
  try {
    messageJSON = JSON.parse(message);
  } catch (e) {
    //
  }

  const fileNameWithSufix = messageJSON.fileName || '';
  const potIndex = fileNameWithSufix.lastIndexOf('.');
  let fileName = fileNameWithSufix.substr(0, potIndex);
  const fileSufix = fileNameWithSufix.substr(potIndex);

  if (fileName.length > 10) {
    fileName = `${fileName.substr(0, 6)}…${fileName.substr(-2)}`;
  }

  const sendMsg = useCallback(() => {
    bus.emit(SEND_MESSAGE, msgContent);
  }, [msgContent]);

  return (
    <MessageContainer fromMe={fromMe}>
      <MessageAvatar
        className={avatarClassName}
        fromMe={fromMe}
        avatar={avatar}
        senderOid={senderOid}
        senderType={senderType}
      />
      <div className={cls(styles.projectMessage, 'ms-content ms-audio-content', { right: fromMe, left: !fromMe })}>
        <div className={styles.messageInner} title={messageJSON.fileName}>
          <div className={styles.content}>
            {fileName}
            {fileSufix}
          </div>
          <div>
            {!error && (
              <img
                src={require('./icon_upload_finished.svg')}
                style={{ width: 16, verticalAlign: 'middle' }}
                alt=""
              />
            )}
            {error ? (
              <span style={{ color: 'red' }}>发送失败</span>
            ) : (
              <span className={styles.successTips}>&nbsp;发送成功</span>
            )}
          </div>
        </div>
        <img
          className={styles.img}
          src={require('./icon_sb3.png')}
          alt=""
        />
      </div>
      {error && (
        <a className={styles.retry} onClick={sendMsg}>
          重发
        </a>
      )}
    </MessageContainer>
  );
};

ProjectMessage.propTypes = {
  error: PropTypes.bool,
  msgContent: PropTypes.object,
  fromMe: PropTypes.bool,
  avatar: PropTypes.string,
  avatarClassName: PropTypes.string,
  senderType: PropTypes.string,
  senderOid: PropTypes.string,
  message: PropTypes.string,
};

export default ProjectMessage;
